export enum AwardBrandType {
  BRAND = 'BRAND',
  PRIVATE_LABEL = 'PRIVATE_LABEL',
}
